<template>
  <div>
    <v-card
      :loading="loading"
      v-if="countAllstd > 0 && loading === false"
      rounded="lg"
      class="animate__animated animate__fadeInUp pa-1"
    >
      <v-toolbar class="elevation-0">
        <v-toolbar-title>
          <lord-icon
            src="https://cdn.lordicon.com/sclmgjsa.json"
            trigger="loop"
            colors="primary:#545454,secondary:#455a64"
            style="width: 50px; height: 50px"
          >
          </lord-icon>
          ผู้เรียนแยกตามสาขาวิชา
          <div v-if="entranceYear" class="caption grey--text">
            ข้อมูล ณ ปีการศึกษา {{ entranceYear }}
          </div>
        </v-toolbar-title>

        <v-spacer></v-spacer>
      </v-toolbar>

      <div id="chart" v-if="loading === false">
        <apexchart
          type="bar"
          height="380"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'DashboardOvecMasterStdBranch',

  data() {
    return {
      ApiKey: 'HRvec2021',
      loading: true,
      series: [],
      chartOptions: {
        chart: {
          type: 'bar',
        },
      },
      countAllstd: 0,
      entranceYear: null,
    }
  },

  async mounted() {
    await this.queryStudentStatSummary()
  },

  methods: {
    async queryStudentStatSummary() {
      try {
        this.loading = true
        let result = await this.$http.post('student_stat_summary_college.php', {
          ApiKey: this.ApiKey,
          college_id: this.college_ID,
        })

        if (!result.data.status) {
          this.countAllstd = 0
          return
        }

        this.entranceYear = result.data.entranceYear
        const rows = result.data.rows || []

        // รวมยอดตามสาขาวิชา (minorNameTh) + ระดับชั้น (gradeNameTh)
        const grouped = {}
        rows.forEach((r) => {
          const key = (r.minorNameTh || 'ไม่ระบุสาขาวิชา') + '|' + (r.gradeNameTh || '')
          if (!grouped[key]) {
            grouped[key] = { branch: r.minorNameTh || 'ไม่ระบุสาขาวิชา', grade: r.gradeNameTh || '', sum: 0 }
          }
          grouped[key].sum += parseInt(r.cnt) || 0
        })

        const entries = Object.values(grouped)
        this.countAllstd = entries.length

        const labelText = entries.map(
          (e) => e.branch + ' : ' + e.grade + ' : ' + e.sum + ' คน'
        )
        const valueshowaf = entries.map((e) => e.sum)
        this.series = [
          {
            data: valueshowaf,
          },
        ]

        this.chartOptions = {
          chart: {
            type: 'bar',
            height: 380,
          },
          plotOptions: {
            bar: {
              borderRadius: 10,
              barHeight: '100%',
              distributed: true,
              dataLabels: {
                position: 'top', // top, center, bottom
              },
            },
          },

          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return val
            },
            offsetY: -20,
            style: {
              fontSize: '12px',
              colors: ['#B3151B'],
            },
          },

          stroke: {
            width: 1,
            colors: ['#fff'],
          },

          xaxis: {
            categories: labelText,
          },
          yaxis: {
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
            labels: {
              show: false,
              formatter: function (val) {
                return val
              },
            },
          },

          tooltip: {
            theme: 'dark',
            x: {
              show: false,
            },
            y: {
              title: {
                formatter: function () {
                  return ''
                },
              },
            },
          },
        }
      } catch (error) {
        this.countAllstd = 0
      } finally {
        this.loading = false
      }
    },
  },

  computed: {
    college_ID(){
      return this.$route.query.college_ID
    }
  },

}
</script>
